/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq5a_Enterprise1Inputs */

const zh_pricing_faq5a_enterprise1 = /** @type {(inputs: Pricing_Faq5a_Enterprise1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果您使用的是企业计划，请联系您的客户代表。`)
};

const en_pricing_faq5a_enterprise1 = /** @type {(inputs: Pricing_Faq5a_Enterprise1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you are on the Enterprise plan, please contact your account representative.`)
};

const es_pricing_faq5a_enterprise1 = /** @type {(inputs: Pricing_Faq5a_Enterprise1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si estás en el plan Empresarial, contacta a tu representante de cuenta.`)
};

/**
* | output |
* | --- |
* | "If you are on the Enterprise plan, please contact your account representative." |
*
* @param {Pricing_Faq5a_Enterprise1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq5a_enterprise1 = /** @type {((inputs?: Pricing_Faq5a_Enterprise1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq5a_Enterprise1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq5a_enterprise1(inputs)
	if (locale === "en") return en_pricing_faq5a_enterprise1(inputs)
	return es_pricing_faq5a_enterprise1(inputs)
});
export { pricing_faq5a_enterprise1 as "pricing_faq5A_enterprise" }